import React from 'react';
import styled from 'styled-components';
import { Paragraph } from '@landr/maestro';
import { Trans } from '@lingui/macro';

const StyledLink = styled.a`
    text-decoration: underline;
`;

export const ShareModalError: React.FC = (): JSX.Element => {
    return (
        <Paragraph contrast="low">
            <Trans>
                We are currently not able to share your track. Please try again
                in a bit or{' '}
                <StyledLink href="https://support.landr.com" target="_blank">
                    contact us
                </StyledLink>{' '}
                if the problem persists.
            </Trans>
        </Paragraph>
    );
};
